import { defaultFontColor, getDefaultFont } from '@nextiva/rich-text-editor';
import {
  STYLING_VALUE_BACKGROUND_POSITION_FILL,
  STYLING_VALUE_BORDER_STYLE_SOLID,
  STYLING_VALUE_FONT_STYLE_NORMAL,
  STYLING_VALUE_FONT_WEIGHT_NORMAL,
  STYLING_VALUE_STICK_TO_TOP,
  STYLING_VALUE_TEXT_DECORATION_NONE,
  STYLING_VALUE_TEXT_TRANSFORM_NONE,
} from 'sharedParts';
import {
  STYLING_KEY_BLOCK,
  STYLING_KEY_BODY,
  STYLING_KEY_BUTTON,
  STYLING_KEY_LABEL,
  STYLING_KEY_OPTION_TEXT,
  STYLING_KEY_PAGE,
  STYLING_KEY_QUESTION_TEXT,
  STYLING_KEY_STATIC_TEXT,
  STYLING_KEY_TEXTFIELD,
} from 'sharedParts/constants/stylingKey';
import {
  FONT_COLOR_KEY,
  FONT_FAMILY_KEY,
  FONT_SIZE_KEY,
  FONT_STYLE_KEY,
  FONT_WEIGHT_KEY,
  SELECTION_COLOR_KEY,
  STICK_TO_KEY,
  TEXT_DECORATION_KEY,
  TEXT_TRANSFORM_KEY,
  BORDER_COLOR_KEY,
  BORDER_RADIUS_KEY,
  BORDER_STYLE_KEY,
  BORDER_WIDTH_KEY,
  BACKGROUND_COLOR_KEY,
  BACKGROUND_IMAGE_KEY,
  BACKGROUND_POSITION_KEY,
  MARGIN_KEY,
} from '../const/StylingSettingKeys';
import { regular, enlarged } from '../../richText/config/DefaultFontSize';

const defaultFont = getDefaultFont(true);

export default {
  [STYLING_KEY_BODY]: {
    [BACKGROUND_COLOR_KEY]: '#fafafa',
    [BACKGROUND_IMAGE_KEY]: null,
    [BACKGROUND_POSITION_KEY]: STYLING_VALUE_BACKGROUND_POSITION_FILL,
  },
  [STYLING_KEY_PAGE]: {
    [BACKGROUND_COLOR_KEY]: '#ffffff',
  },
  [STYLING_KEY_BLOCK]: {
    [MARGIN_KEY]: 0,
  },
  [STYLING_KEY_LABEL]: {
    [FONT_COLOR_KEY]: '#95989a',
    [FONT_SIZE_KEY]: 14,
    [FONT_STYLE_KEY]: STYLING_VALUE_FONT_STYLE_NORMAL,
    [FONT_WEIGHT_KEY]: STYLING_VALUE_FONT_WEIGHT_NORMAL,
    [STICK_TO_KEY]: STYLING_VALUE_STICK_TO_TOP,
    [TEXT_DECORATION_KEY]: STYLING_VALUE_TEXT_DECORATION_NONE,
    [TEXT_TRANSFORM_KEY]: STYLING_VALUE_TEXT_TRANSFORM_NONE,
  },
  [SELECTION_COLOR_KEY]: '#f4ae1b',
  [STYLING_KEY_STATIC_TEXT]: {
    [FONT_SIZE_KEY]: enlarged,
    [FONT_FAMILY_KEY]: defaultFont,
    [FONT_COLOR_KEY]: defaultFontColor,
    [FONT_STYLE_KEY]: STYLING_VALUE_FONT_STYLE_NORMAL,
    [FONT_WEIGHT_KEY]: STYLING_VALUE_FONT_WEIGHT_NORMAL,
    [TEXT_DECORATION_KEY]: STYLING_VALUE_TEXT_DECORATION_NONE,
    [TEXT_TRANSFORM_KEY]: STYLING_VALUE_TEXT_TRANSFORM_NONE,
  },
  [STYLING_KEY_TEXTFIELD]: {
    [BACKGROUND_COLOR_KEY]: '#ffffff',
    [BORDER_COLOR_KEY]: '#cccccc',
    [BORDER_RADIUS_KEY]: 3,
    [BORDER_STYLE_KEY]: STYLING_VALUE_BORDER_STYLE_SOLID,
    [BORDER_WIDTH_KEY]: 1,
    [FONT_COLOR_KEY]: '#333333',
    [FONT_SIZE_KEY]: 16,
    [FONT_STYLE_KEY]: STYLING_VALUE_FONT_STYLE_NORMAL,
    [FONT_WEIGHT_KEY]: STYLING_VALUE_FONT_WEIGHT_NORMAL,
    [TEXT_DECORATION_KEY]: STYLING_VALUE_TEXT_DECORATION_NONE,
    [TEXT_TRANSFORM_KEY]: STYLING_VALUE_TEXT_TRANSFORM_NONE,
  },
  [STYLING_KEY_QUESTION_TEXT]: {
    [FONT_SIZE_KEY]: enlarged,
    [FONT_FAMILY_KEY]: defaultFont,
    [FONT_COLOR_KEY]: defaultFontColor,
    [FONT_STYLE_KEY]: STYLING_VALUE_FONT_STYLE_NORMAL,
    [FONT_WEIGHT_KEY]: STYLING_VALUE_FONT_WEIGHT_NORMAL,
    [TEXT_DECORATION_KEY]: STYLING_VALUE_TEXT_DECORATION_NONE,
    [TEXT_TRANSFORM_KEY]: STYLING_VALUE_TEXT_TRANSFORM_NONE,
  },
  [STYLING_KEY_OPTION_TEXT]: {
    [FONT_SIZE_KEY]: regular,
    [FONT_FAMILY_KEY]: defaultFont,
    [FONT_COLOR_KEY]: defaultFontColor,
    [FONT_STYLE_KEY]: STYLING_VALUE_FONT_STYLE_NORMAL,
    [FONT_WEIGHT_KEY]: STYLING_VALUE_FONT_WEIGHT_NORMAL,
    [TEXT_DECORATION_KEY]: STYLING_VALUE_TEXT_DECORATION_NONE,
    [TEXT_TRANSFORM_KEY]: STYLING_VALUE_TEXT_TRANSFORM_NONE,
  },
  [STYLING_KEY_BUTTON]: {
    [FONT_SIZE_KEY]: 14,
    [FONT_COLOR_KEY]: '#ffffff',
    [FONT_WEIGHT_KEY]: 'bold',
    [FONT_STYLE_KEY]: 'normal',
    [TEXT_DECORATION_KEY]: 'none',
    [TEXT_TRANSFORM_KEY]: 'none',
    [BORDER_WIDTH_KEY]: 2,
    [BORDER_STYLE_KEY]: 'none',
    [BORDER_RADIUS_KEY]: 4,
    [BORDER_COLOR_KEY]: '#000000',
    [BACKGROUND_COLOR_KEY]: '#999999',
  },
};
